import React from "react";
import { CpButton } from "canopy-styleguide!sofe";
import { useCss, k, a, m } from "kremling";
import { tw, always } from "src/tailwind";

interface SetupMfaAuthProps {
  mobile: boolean;
  navigate: (step: string, updateBannerText?: string) => void;
  onBack: () => void;
  generateSecretCode: () => void;
}

export function SetupMfaAuth({ mobile, navigate, generateSecretCode }: SetupMfaAuthProps) {
  const scope = useCss(css);

  return (
    <div {...scope} className="setup-mfa-auth-container">
      <div className="cp-mb-24 auth-message">
        Your admin has updated the MFA settings for your firm. You will need to download an authenticator app to log in.
      </div>
      <div className={always(tw("flex flex-center justify-center gap-4"), "cp-mb-40")}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://apps.apple.com/us/app/google-authenticator/id388497605"
        >
          <img
            src="https://cdn.canopytax.com/static/global-settings/mobile/ios-store.png"
            alt="Download on the App Store"
          />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US"
        >
          <img
            src="https://cdn.canopytax.com/static/global-settings/mobile/android-store.png"
            alt="Get it on Google Play"
          />
        </a>
      </div>
      <div className={a("cp-flex cp-mt-40").m("mobile-button-group", mobile)}>
        <CpButton type="button" onClick={generateSecretCode}>
          Next
        </CpButton>
        <CpButton btnType="secondary" onClick={() => navigate("mfa-selection")} className={m("cp-ml-16", !mobile)}>
          Back
        </CpButton>
      </div>
    </div>
  );
}

const css = k`
  .mobile-button-group {
    display: flex;
    flex-direction: column;
    height: 12.8rem;
    justify-content: space-between;
  }
  .mobile-button-group .cp-button {
    width: 100%;
  }
`;
